import React from "react";
import { graphql } from "gatsby";
import { Table as TableComponent } from "@zempler/theme/src/components/table/Table";

export const Table = ({ data, ...rest }) => {
  return <TableComponent {...data} />;
};

export const TableQuery = graphql`
  fragment Table on UMBRACO_TableComponentType {
    firstColumnHeading
    rows {
      heading
      cells {
        heading
        content
      }
    }
  }
`;
